import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import { CardWrapper, CardSection, CardIcon } from 'components/Shared/Cards';
import { CARDS } from 'theme';
import { CustomWrapper, FlexRow } from 'components/Shared/Scaffolding';

const propTypes = {
    onClick: PropTypes.func,
    children: PropTypes.node.isRequired,
};

const defaultProps = {
    onClick: null,
};

const StyledCardContent = styled(FlexRow)`
    padding: ${CARDS.GUTTER};
`;

const StyledFlexContent = CustomWrapper(
    css`
        flex: 1 1 auto;
        width: 100%;
        min-width: 50%;
    `
);

const Card = ({ onClick, leftGlyph, leftGlyphColor, rightGlyph, rightGlyphColor, children, ...props }) => {
    const hasGlyph = leftGlyph || rightGlyph;
    const content = <StyledFlexContent inline={!!onClick}>{children}</StyledFlexContent>;

    return hasGlyph ? (
        <CardWrapper onClick={onClick} {...props}>
            <StyledCardContent alignCenter inline={!!onClick} hasGlyph={hasGlyph}>
                {leftGlyph && <CardIcon glyph={leftGlyph} color={leftGlyphColor} />}
                {content}
                {rightGlyph && <CardIcon primary glyph={rightGlyph} color={rightGlyphColor} />}
            </StyledCardContent>
        </CardWrapper>
    ) : (
        <CardWrapper onClick={onClick} {...props}>
            <CardSection>{children}</CardSection>
        </CardWrapper>
    );
};

Card.propTypes = propTypes;
Card.defaultProps = defaultProps;

export default Card;
